
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/quickEditEngine/components/styles/innerDrillIn.scss.css.virtualfile';
        module.exports = {"innerDrillInPanel":"_innerDrillInPanel_18m2f_7","innerDrillInContent":"_innerDrillInContent_18m2f_15"};